import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-orange-400 text-black p-4 text-center h-10 flex justify-center items-center">
            All rights reserved &copy; 2024
        </footer>
    );
};

export default Footer;